import { useParams, Link } from "react-router-dom";
import { getBlogPostBySlug } from "../data/blogPosts";
import EnquiryForm from "../components/common/EnquiryForm";

export default function BlogPost() {
  const { slug } = useParams();
  const post = getBlogPostBySlug(slug);

  if (!post) {
    return (
      <main className="pt-16 md:pt-20 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-gray-900 mb-4">Post not found</h1>
          <Link to="/community" className="text-teal-700 hover:underline text-base">Back to community</Link>
        </div>
      </main>
    );
  }

  return (
    <main className="pt-16 md:pt-20">
      <section
        className="relative h-64 md:h-80 flex items-center justify-center"
        style={{ backgroundImage: `url('${post.heroImageUrl}')`, backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 text-center text-white px-4 max-w-3xl mx-auto">
          <h1 className="text-2xl md:text-4xl font-semibold">{post.title}</h1>
        </div>
      </section>

      <section className="max-w-2xl mx-auto px-4 sm:px-6 py-12">
        <Link to="/community" className="text-base text-teal-700 hover:underline mb-8 inline-block">← Back to community</Link>
        <div>
          {post.content.split("\n\n").map((para, i) => (
            <p key={i} className="text-gray-600 leading-relaxed text-base mb-4">{para}</p>
          ))}
        </div>
      </section>

      <EnquiryForm pageUri={`https://artistic-spaces.co.uk/blog/${slug}`} pageName={post.title} />
    </main>
  );
}